module.exports = __webpack_public_path__ + "static/media/Group222.9454d30c.png";